var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent"},_vm._l((_vm.items),function(note,index){return _c('NoteCard',{key:index,attrs:{"note":note,"isRecent":true,"variant":"transparent"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }